import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, message } from "antd";
import { useEffect } from "react";
import { handleDeleteLevel } from "../../../api/matrix";

export default function DeleteLevel({
  isVisible,
  setVisible,
  selectedLevel,
  selectedRole,
}: any) {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isPending } = useMutation({
    mutationFn: handleDeleteLevel,
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["roles"] });
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const onSubmit = async () => {
    const { description } = await form.getFieldsValue();
    const data = {
      description,
    };
    await mutate({ _id: selectedRole?._id, levelId: selectedLevel?._id, data });
    setVisible(false);
  };

  const clearForm = async () => {
    // form.resetFields();
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selectedLevel, form]);

  return (
    <Modal
      open={isVisible}
      title="Delete Level"
      onCancel={() => setVisible(false)}
      footer={[
        <Button key="back" onClick={clearForm}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="deleteLevel"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isPending}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form
        id="deleteLevel"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="flex flex-col items-center justify-center my-8">
          <div>
            Are you Sure you want to
            <span className="text-automark-dark font-bold mx-1">Delete</span>
            Record
          </div>
          <div className="font-bold text-lg">
            Level {selectedLevel?.level} : {selectedLevel?.description}?
          </div>
          <div className="text-xs">on {selectedLevel?.moduleName} module</div>
        </div>
      </Form>
    </Modal>
  );
}
